import PayTypesServices from "../../../../../services/PayTypesServices";
import { capitalizeFirstLetter, currencyFormat } from "../../../../../utils";
import { deepGet, formatter } from "../../../../../utils/utility";
import {
  AllPayTypesProp,
  DataProps,
  PolicyCoverage,
  PriceProps,
  TableCoverage,
} from "./travel-result-types";

export const GuaranteeTableColumns = [
  {
    text: "Coberturas incluidas en la póliza",
    filter: false,
    ascendent: true,
    key: "highlighted",
  },
  {
    text: "",
    filter: false,
    ascendent: true,
    key: "highlighted",
  },
];

export const PaymentTableColumns = [
  {
    text: "Periodicidad",
    filter: false,
    ascendent: true,
    key: "highlighted",
  },
  {
    text: "Total prima neta",
    filter: false,
    ascendent: true,
    key: "",
  },
  {
    text: "Impuestos y consorcio",
    filter: false,
    ascendent: false,
    key: "",
  },
  {
    text: "Total recibo",
    filter: false,
    ascendent: true,
    key: "",
  },
];

export const getGuaranteeTableRowsTravel = ({ data }: { data: DataProps }): TableCoverage[] => {
  let orderedCoverages: PolicyCoverage[] = data.taker.policy.coverages.sort((a, b) => {
    if (a.code > b.code) return 1;
    else return -1;
  });
  let coverages: { name: string; capital: any }[] = [];

  orderedCoverages.map((coverage) => {
    coverages.push({
      name: coverage.description,
      capital: 1,
    });
  });

  return coverages.map((c) => ({
    coverages: {
      text: c.name ? capitalizeFirstLetter(c.name.toLowerCase()) : "",
      type: "",
      link: "",
      key: "entire-mini-body",
    },
    capital: {
      text:
        c.capital === 1 || c.capital === formatter.format(1.0)
          ? "Incluido"
          : currencyFormat(c.capital) + " €",
      type: "",
      link: "",
      key: "highlighted",
    },
  }));
};

export const getPaymentTableRows = ({
  allPayTypes,
  data,
}: {
  allPayTypes: AllPayTypesProp[];
  data: DataProps;
}) => {
  const price: PriceProps | undefined = deepGet(data, "priceData.price");
  if (!price) return;

  const paymentTableRows = [
    {
      periodicity: {
        text: PayTypesServices.getPayTypeByCode(allPayTypes, price.payType).description,
        order: PayTypesServices.getPayTypeByCode(allPayTypes, price.payType).payTypeOrder,
        type: "",
        link: "",
        key: "highlighted",
      },
      netPremium: {
        text: `${currencyFormat(price.netPremium)} €`,
        type: "",
        link: "",
        key: "body",
      },
      taxs: {
        text: `${currencyFormat(price.taxs)} €`,
        type: "",
        link: "",
        key: "body",
      },
      total: {
        text: `${currencyFormat(price.totalPremium)} €`,
        type: "",
        link: "",
        key: "body",
      },
    },
  ];

  return paymentTableRows;
};
